module.exports = __webpack_public_path__ + "static/media/5.f1b8f177.jpg";